import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore"; 
import { Permissions } from "ts-interfaces"; 

const cache = new Map<string, any>(); 
export async function getDesignFirmsOfUser(userId: string, db: any, useCache: boolean = true): Promise<any> { 
    try { 

        const cacheKey = `${userId}`; 
        if (useCache && cache.has(cacheKey)) return cache.get(cacheKey)!;         
        const docRef = doc(db, 'permissions', userId);
        const docSnapshot = await getDoc(docRef);
        if (!docSnapshot.exists()) { return []; }
        const permissionsData = docSnapshot.data() as Permissions;
        const result = permissionsData.teamsDesigner
        if (useCache) cache.set(cacheKey, result); 
        return result; 

    } catch (error) { 
        console.error("Error checking user permissions:", error); 
        return false; 
    } 
} 

const teamCache = new Map<string, any[]>(); 
export async function getDesignersWithAccess(designFirmId: string, db: any, useCache: boolean = true): Promise<any[]> { 
    try { 
        const cacheKey = designFirmId; 
        if (useCache && teamCache.has(cacheKey)) return teamCache.get(cacheKey)!; 
        const teamsQuery = query(collection(db, "teams"), where("designFirmID", "==", designFirmId), where("status", "==", "active")); 
        const querySnapshot = await getDocs(teamsQuery); 
        if (querySnapshot.empty) {  return []; } 
        const teamMembers = querySnapshot.docs.map(doc => doc.data()); 
        if (useCache) teamCache.set(cacheKey, teamMembers); 
        return teamMembers; 
    } catch (error) { 
        console.error("Error fetching team members:", error); 
        return []; 
    } 
} 
